//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/area-restrita',
      en: '/restricted-area',
      es: '/area-restringida'
    }
  },

  middleware: ['not-authenticated.middleware'],

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: 'Área Restrita'
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: 'Home',
          path: '/'
        },
        {
          name: 'Área Restrita',
          path: this.$route.fullPath
        }
      ]

      return breadcrumbs
    }
  }
}
